//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "staffentryofficialexaminfo",
  props: {
    //业务数据
    record: {
      type: Object,
      default: () => ({})
    },
    //流程数据
    process: {
      type: Object,
      default: () => ({})
    },
    //规则绑定
    rules: {
      type: Object,
      default: () => ({})
    },
    //自定义的参数
    config: {
      type: Object,
      default: () => ({})
    },
  }
}




// WEBPACK FOOTER //
// ./src/pcpage/hr/personnel/staffentry/staffentryofficialexaminfo.vue